import {useMemo} from 'react'

import Timeline from '../../common/components/Details/Timeline/index.js'
import {
  createPOCommentGroupsSelector,
  ensurePOComments,
  isPOLockedSelector,
} from '../../data/pos.js'
import {showAddPOCommentModal} from '../PurchaseOrderListPage/Modals/AddPOCommentModal.js'
import {poIDSelector} from './poDetailSelectors.js'
import {useSelector} from '../../store.js'

export default function POTimeline() {
  const poID = useSelector(poIDSelector)
  const commentGroupsSelector = useMemo(
    () => createPOCommentGroupsSelector(poID),
    [poID],
  )
  const isPOLocked = useSelector((state) => isPOLockedSelector(state, {poID}))

  return (
    <div className="wrap--row flex">
      <div className="medium-7 columns">
        <Timeline
          commentGroupsSelector={commentGroupsSelector}
          readOnly={isPOLocked}
          addComment={() => showAddPOCommentModal(poID)}
          ensureComments={() => ensurePOComments(poID)}
        />
      </div>
    </div>
  )
}
